import { ToastProps } from 'react-native-toast-notifications/lib/typescript/toast';

export interface IMenuToastTemplate {
  toast: ToastProps;
}

export enum MenuToastEventTypes {
  ADD_TO_CART = 'addToCart',
}
